import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getWoundCareSelector } from '../selectors'
import { saveWoundCare } from '../store/woundCare.actions'
import { WoundCareConstants } from '../store/woundCare.constants'
import { IWoundCareState } from '../store/woundCare.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const woundCareState: IWoundCareState = yield select(getWoundCareSelector)
  const { comments } = woundCareState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.woundCareStateList && pcrDoc.patient?.woundCareStateList.length) {
      const index = pcrDoc.patient?.woundCareStateList?.findIndex((woundCare) => woundCare.key === woundCareState.key)
      if (index !== -1) {
        if (pcrDoc.patient.woundCareStateList[index].comments !== comments) {
          yield put(saveWoundCare())
        }
      }
    } else {
      yield put(saveWoundCare())
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([WoundCareConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
